import React, { useRef, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogHeader from "@mui/material/DialogTitle";
import Paper from '@material-ui/core/Paper';
import CloseIcon from "@material-ui/icons/Close";
import { IconButton } from "@material-ui/core";
import "../../styles/devices/mob_SignDialog.css";
import { LinearProgress } from "@material-ui/core";
import { useDataProvider } from "../../api/DataProvider";
import { pDataProvider } from "../../utils/parameters";
import { useStyles } from "../../styles/SignDialog";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Divider from '@material-ui/core/Divider';
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import { withStyles } from '@material-ui/core/styles';

const StyledIconButton = withStyles({
    root: {
      padding: 0,
      marginRight: '5px',
    },
  })(IconButton);


export function SentenceAnswerDialog(props) {
    const { arr_question_data, arr_awnswer_data, setOpenSentenceQuestionElementSelected, setOpenSentenceAnswerElementSelected, openSentenceAnswerElementSelected } = props;

    const { json_data_answer, json_data_question, comm_getPublicURLVideoData } = useDataProvider();
    const [ text, setText ] = useState(null)
    const [ selected_video, setSelected_video ] = useState(null) 
    const [ videoLoaded, setVideoLoaded ] = useState(false) 
    const styles = useStyles();
    const [ arrDataGrid, setArrDataGrid ] = useState([]) 
    const [showQuestions, setShowQuestions] = useState(false)

    useEffect(() => {
        console.log("🚀 ~ SentenceAnswerDialog ~ openSentenceAnswerElementSelected:", openSentenceAnswerElementSelected)
        if (openSentenceAnswerElementSelected !== null) {         
            setText( arr_awnswer_data[openSentenceAnswerElementSelected].text)
            setSelected_video( comm_getPublicURLVideoData(pDataProvider.dir_vid_answer, openSentenceAnswerElementSelected ))
            setVideoLoaded(true)

            const arr_question_idx = arr_awnswer_data[openSentenceAnswerElementSelected].arr_questions
            console.log("🚀 ~ file: SentencesTable.js:43 ~ aquiggg handleAccordionClick ~ arr_question_idx:", arr_question_idx)

            const arrData = arr_question_idx.map((elemento, indice) => {
                return { 'id': elemento, 'text': arr_question_data[elemento].text};
            });
            console.log("🚀 ~ file: SentencesTable.js:47 ~ aquiggg handleAccordionClick ~ arrData:", arrData)

            setArrDataGrid(arrData) 


        }else{
            setText('')
            setSelected_video(null)
        }

    } ,[openSentenceAnswerElementSelected]);

    const handleClickClose = () => {
        setOpenSentenceAnswerElementSelected(null)
        setShowQuestions(false)
    }

    const handleShowHideQuestions = () => {
        setShowQuestions(!showQuestions)
    }

    const handleClickElement = (item, index) => {
        console.log("🚀 ~ handleClickElement ~ index:", index)
        console.log("🚀 ~ handleClickElement ~ item:", item)
        setOpenSentenceQuestionElementSelected(item.id)
        handleClickClose()
    }

    const handlePushScreenCollaborator = () => {
        console.log("🚀 ~ handlePushScreenCollaborator ~ handlePushScreenCollaborator:", handlePushScreenCollaborator)
    }   
    

    return (
        
        <Dialog className="sig_SignModal_Dialog" open={openSentenceAnswerElementSelected!==null} onClose={handleClickClose}>
            <DialogHeader>
                <div style={{ maxWidth: '400px', fontSize: '16px'}} className="sig_Game_DialogTitle">
                    <d> RESPUESTA: </d> <d style={{fontWeight: 'normal', color: 'black'}}> {text} </d>
                </div>
                <IconButton aria-label="close" className="sig_Game_CloseButton" onClick={handleClickClose}>
                    <CloseIcon />
                </IconButton>
            </DialogHeader>
            <Divider />
            <DialogContent className="sig_SignModal_DialogContent" >
                <div className="sig_SignModal_VideoContainer">
                {!videoLoaded && <LinearProgress className={styles.videoLoading} color="primary" />}
                <video style={{width: '100%'}} autoPlay loop muted>
                    <source src={selected_video} type="video/mp4" />
                </video>
                </div>

                <div style={{padding: '20px', marginTop: '-50px'}}>
                <Button className="sig_SignDialog_Button sig_SignDialog_ButtonRecord" endIcon={<SendIcon />} onClick={handlePushScreenCollaborator}>
                    {"Grabar respuesta"}
                </Button>

                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', margin: 'auto' }}>
                    <div style={{backgroundColor: '#1880d2', color: 'white', padding: '10px', borderRadius: '10px'}}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '25px' }}>
                            <div style={{ flex: 4}}>
                                <strong>PREGUNTAS ASOCIADAS</strong>
                            </div>
                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', marginRight: 10 }}>
                                <IconButton onClick={handleShowHideQuestions}>
                                    {showQuestions ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </IconButton>
                            </div>
                        </div>
                    </div>
                    {showQuestions &&
                    <>
                        {arrDataGrid.map((item, index) => (
                            <div 
                                key={index} 
                                style={{ display: 'flex', alignItems: 'center', textAlign: 'center', padding: '10px', borderBottom: '1px solid #ccc'}}
                            >
                                <StyledIconButton 
                                onClick={(event) => {
                                    handleClickElement(item, index)
                                }} 
                                > 
                                    <PlayCircleOutlineIcon style={{ color: '#0e72c1' }} /> 
                                    </StyledIconButton>
                                    <div style={{ flex: 1 }}>
                                    {item.text}
                                </div>
                            </div>
                        ))}
                    </>
                    }
                </div>
                </div>
            </DialogContent>
        </Dialog>

    )

}